import React from 'react';
import Title from '../Title';
import Cards from '../Cards';
import products from '../../data/products.js';
import { useTranslation } from 'react-i18next';

const IllustrationSection = () => {
  const { t } = useTranslation();

  const translatedProducts = products.map((product, index) => ({
    ...product,
    title: t(`products.products_list.list_item_${index}.title`),
  }));

  return (
    <div className='flex flex-col p-6 md:p-12 gap-6 md:gap-12'>
      <Title>{t('products.products_title')}</Title>
      <div className='text-center'>
        <p className='text-lg lg:text-xl font-light text-gray-500'>
          {t('products.products_subtitle')}
          <span className='font-medium text-primary-red'> Quantessence </span>
        </p>
      </div>
      <Cards
        items={translatedProducts}
        linkPrefix='/illustrations/product'
        imageKey='imagedisplay'
        titleKey='title'
        linkKey='slug'
        setCategory={() => {}}
        applyObjectTop={true}
      />
    </div>
  );
};

export default IllustrationSection;
